import type { Faq, UpdateFaqPayload } from '../entities/faq.entity'
import type { FaqRepository } from '../repositories/faq_repository'

export class UpdateFaqUseCase {
  constructor(private readonly repository: FaqRepository) {}

  execute(payload: UpdateFaqPayload): Promise<Faq> {
    return this.repository.update(payload)
  }
}
